import { HiMenuAlt3 } from "react-icons/hi";
import { NavLink } from "react-router-dom"
import "../styles/Navbar.css"
import { useState } from "react";


const Navbar = () => {
    const activeStyle = {
        color: "#757575",
      };

    const [navResponsive, setNavResponisve] = useState(false)

    return<>
        <nav>
            <div className={window.innerWidth <= 500 && navResponsive ?  "navigations" : window.innerWidth > 500 ? "navigations" : "hide"}>
                <NavLink
                    to={"/"}
                    style={({ isActive }) => (isActive ? activeStyle : undefined)}
                    end
                >
                    Home
                </NavLink>
                <NavLink
                    to={"/gallery"}
                    style={({ isActive }) => (isActive ? activeStyle : undefined)}
                    end
                >
                    Gallery
                </NavLink>
                <NavLink
                    to={"/tributes"}
                    style={({ isActive }) => (isActive ? activeStyle : undefined)}
                    end
                >
                    Tributes
                </NavLink>
                <NavLink
                    to={"/burial-arrangements"}
                    style={({ isActive }) => (isActive ? activeStyle : undefined)}
                    end
                >
                    Burial Arrangements
                </NavLink>
            </div>
            <div className="menu"  onClick={() => setNavResponisve(!navResponsive)}>
                <HiMenuAlt3 />  
            </div>
        </nav>

    </>

}


export default Navbar